import { httpClient } from '@/services/http/httpClient'

export type VideoComment = {
  id: string
  text: string
  likes: number
  commentListId: string
  userId: string
  createdAt: string
  subCommentsList?: VideoComment[]
  liked: boolean
  userImage: string | null
  userName: string
}

type CommentSerialized = {
  commentList?: VideoComment[]
}

export async function getComments(videoId: number): Promise<CommentSerialized> {
  const { data } = await httpClient.get<VideoComment[]>(
    `/users/videos/comments?videoId=${videoId}`,
  )

  return { commentList: data }
}
